import { isEmpty } from 'lodash';
import { useQuery } from 'react-query';
import { queryGet } from '../../../utils/queryClient';

export default function useArtistEventsQuery({
  artistId,
  memberId,
  category,
  photoCardCategories,
  eventType
}) {
  const queryParams = new URLSearchParams();

  if (memberId) {
    queryParams.append('member_id', memberId);
  }

  if (category) {
    queryParams.append('category', category);
  }

  if (!isEmpty(photoCardCategories)) {
    queryParams.append('photo_card_categories', photoCardCategories);
  }

  if (eventType) {
    queryParams.append('event_type', eventType);
  }

  const { data: events } = useQuery(
    ['events', artistId, memberId, category, photoCardCategories, eventType],
    () => queryGet(`/artists/${artistId}/events?${queryParams.toString()}`),
    {
      enabled: !!artistId,
      select: (data) => data.events
    }
  );
  return events;
}
